export default __webpack_public_path__ + "static/media/digitVector.94b33955.svg";